export const GIFT_VOUCHER_LIST = "GIFT_VOUCHER_LIST";
export const GIFT_VOUCHER_LIST_SUCCESS = "GIFT_VOUCHER_LIST_SUCCESS";
export const GIFT_VOUCHER_LIST_FAILURE = "GIFT_VOUCHER_LIST_FAILURE";

export const GIFT_VOUCHER_DATA = "GIFT_VOUCHER_DATA";
export const GIFT_VOUCHER_DATA_SUCCESS = "GIFT_VOUCHER_DATA_SUCCESS";
export const GIFT_VOUCHER_DATA_FAILURE = "GIFT_VOUCHER_DATA_FAILURE";

export const GIFT_VOUCHER_CREATE = "GIFT_VOUCHER_CREATE";
export const GIFT_VOUCHER_CREATE_SUCCESS = "GIFT_VOUCHER_CREATE_SUCCESS";
export const GIFT_VOUCHER_CREATE_FAILURE = "GIFT_VOUCHER_CREATE_FAILURE";

export const GIFT_VOUCHER_UPDATE = "GIFT_VOUCHER_UPDATE";
export const GIFT_VOUCHER_UPDATE_SUCCESS = "GIFT_VOUCHER_UPDATE_SUCCESS";
export const GIFT_VOUCHER_UPDATE_FAILURE = "GIFT_VOUCHER_UPDATE_FAILURE";

export const GIFT_VOUCHER_DELETE = "GIFT_VOUCHER_DELETE";
export const GIFT_VOUCHER_DELETE_SUCCESS = "GIFT_VOUCHER_DELETE_SUCCESS";
export const GIFT_VOUCHER_DELETE_FAILURE = "GIFT_VOUCHER_DELETE_FAILURE";

export const GIFT_VOUCHER_SEARCH = "GIFT_VOUCHER_SEARCH";
export const GIFT_VOUCHER_SEARCH_SUCCESS = "GIFT_VOUCHER_SEARCH_SUCCESS";
export const GIFT_VOUCHER_SEARCH_FAILURE = "GIFT_VOUCHER_SEARCH_FAILURE";

export const GIFT_VOUCHER_REDEEM = "GIFT_VOUCHER_REDEEM";
export const GIFT_VOUCHER_REDEEM_SUCCESS = "GIFT_VOUCHER_REDEEM_SUCCESS";
export const GIFT_VOUCHER_REDEEM_FAILURE = "GIFT_VOUCHER_REDEEM_FAILURE";

export const GIFT_VOUCHER_VOID = "GIFT_VOUCHER_VOID";
export const GIFT_VOUCHER_VOID_SUCCESS = "GIFT_VOUCHER_VOID_SUCCESS";
export const GIFT_VOUCHER_VOID_FAILURE = "GIFT_VOUCHER_VOID_FAILURE";

export const GIFT_VOUCHER_RESEND_EMAIL = "GIFT_VOUCHER_RESEND_EMAIL";
export const GIFT_VOUCHER_RESEND_EMAIL_SUCCESS =
  "GIFT_VOUCHER_RESEND_EMAIL_SUCCESS";
export const GIFT_VOUCHER_RESEND_EMAIL_FAILURE =
  "GIFT_VOUCHER_RESEND_EMAIL_FAILURE";
